import React from 'react';

/**
 * Confirmation modal for deleting the article.
 * Extracted verbatim from pages/Articles/Article.js.
 */
export default function DeleteArticleModal({
  confirmDeleteArticle,
  isDeletingArticle,
  setShowDeleteArticleModal,
  title,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Delete Article?
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to delete "<strong>{title}</strong>"? This action cannot be undone.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={() => setShowDeleteArticleModal(false)}
            disabled={isDeletingArticle}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={confirmDeleteArticle}
            disabled={isDeletingArticle}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isDeletingArticle ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                Deleting...
              </>
            ) : (
              'Delete Article'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
